import highlight from '@mdx-deck/themes/syntax-highlighter-prism';
import Slide from "../../../../src/templates/slide";
import FullViewportSlide from "../../../../src/templates/full-viewport-slide";
import ImageSlide from "../../../../src/templates/image-slide";
import CodeBlock from "../../../../src/components/code-figure";
import A11yDiagram from "../../../../src/components/a11y-diagram";
import SearchContainer from "../../../../src/components/search-input";
import AvoidTheMouse from "../../../../src/components/avoid-mouse";
import UserPopover from "../../../../src/components/user-popover";
import KeyboardTrapDemo from "../../../../src/components/demo1";
import CarouselDemo from "../../../../src/components/demo2";
import DialogTabceptionDemo from "../../../../src/components/dialog-tabception";
import CanvasDemo from "../../../../src/components/canvas";
import DataViz from "../../../../src/components/dataviz";
import baseTheme from "../../../../src/theme";
import React from 'react';
export default {
  highlight,
  Slide,
  FullViewportSlide,
  ImageSlide,
  CodeBlock,
  A11yDiagram,
  SearchContainer,
  AvoidTheMouse,
  UserPopover,
  KeyboardTrapDemo,
  CarouselDemo,
  DialogTabceptionDemo,
  CanvasDemo,
  DataViz,
  baseTheme,
  React
};